import React from 'react';
import LeftSideItem from './LeftSideItem';
import FavoriteIcon from '@material-ui/icons/Favorite';
import TagFacesIcon from '@material-ui/icons/TagFaces';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import FlagSharpIcon from '@material-ui/icons/FlagSharp';
import HistoryIcon from '@material-ui/icons/History';
import WorkIcon from '@material-ui/icons/Work';
import StarIcon from '@material-ui/icons/Star';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import SupervisedUserCircleRoundedIcon from '@material-ui/icons/SupervisedUserCircleRounded';
import './Sidebar.css';
import { Link } from 'react-router-dom';

 

 

const LeftSide = ({user}) => {
  
    return ( 
        <div className='leftSide pl-3 pt-3'>
        <Link to={`/${user.displayName}`}>
        <h4><img src={user.photoURL} alt="" /> {user.displayName}</h4>
         </Link>
           
          <LeftSideItem name={' COVID-19 information Center'} Icon={FavoriteIcon}/> 
          <LeftSideItem name={' Friends'} Icon={SupervisorAccountIcon}/> 
          <LeftSideItem name={' Groups'} Icon={SupervisedUserCircleRoundedIcon}/>
          <LeftSideItem name={' Pages'} Icon={FlagSharpIcon}/> 
          <LeftSideItem name={' Memories'} Icon={HistoryIcon}/> 
          <LeftSideItem name={' Jobs'} Icon={WorkIcon}/> 
          <LeftSideItem name={' Favorites'} Icon={StarIcon}/> 
          <LeftSideItem name={' Watch'} Icon={LiveTvIcon}/> 
          <LeftSideItem name={' Saved'} Icon={BookmarkBorderOutlinedIcon}/> 
          <LeftSideItem name={' Friends2'} Icon={TagFacesIcon}/>
          <LeftSideItem name={' Jobs2'} Icon={WorkIcon}/> 
          <LeftSideItem name={' Favorites2'} Icon={StarIcon}/> 
          <LeftSideItem name={' Watch2'} Icon={LiveTvIcon}/> 
          <LeftSideItem name={' Saved2'} Icon={BookmarkBorderOutlinedIcon}/> 
          
        </div> 
    );
};

export default LeftSide;